import { GithubServiceInfo } from './providers/github/index.esm.js';
import { GitlabServiceInfo } from './providers/gitlab/index.esm.js';
import { ProviderEnum } from '../utils/enum.esm.js';

class ProviderService {
  constructor(provider, host, token) {
    this.provider = provider;
    this.host = host;
    this.token = token;
    ProviderService.githubInfo = new GithubServiceInfo(this.host, this.token);
    ProviderService.gitlabInfo = new GitlabServiceInfo(this.host, this.token);
  }
  static githubInfo;
  static gitlabInfo;
  async getUserAndOrgs() {
    switch (this.provider) {
      case ProviderEnum.GITHUB:
        return {
          username: await ProviderService.githubInfo.getUserGithub(),
          organizations: await ProviderService.githubInfo.getOrgsGithub()
        };
      case ProviderEnum.GITLAB:
        return {
          username: await ProviderService.gitlabInfo.getUserGitlab(),
          organizations: await ProviderService.gitlabInfo.getOrgsGitlab()
        };
      default:
        return { username: "Not Found", organizations: ["Not Found"] };
    }
  }
  async getOgs(provider) {
    switch (provider) {
      case ProviderEnum.GITHUB:
        return await ProviderService.githubInfo.getOrgsGithub();
      case ProviderEnum.GITLAB:
        return await ProviderService.gitlabInfo.getOrgsGitlab();
      default:
        return ["not orgs avaliable"];
    }
  }
  async getUser(provider) {
    switch (provider) {
      case ProviderEnum.GITHUB:
        return await ProviderService.githubInfo.getUserGithub();
      case ProviderEnum.GITLAB:
        return await ProviderService.gitlabInfo.getUserGitlab();
      default:
        return "Not Owner avaliable";
    }
  }
}

export { ProviderService };
//# sourceMappingURL=ProviderService.esm.js.map
